
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/politica-de-privacidad",
      function () {
        return require("private-next-pages/politica-de-privacidad.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/politica-de-privacidad"])
      });
    }
  